import { useQuery } from '@tanstack/react-query'

import { BankService } from '@/api/services/BankService'
import { IBankInstitution } from '@/types'

// One query shared by the list and the detail page.
//
// There is no per-institution endpoint yet (YAR-14652 covers the list only),
// so the detail view picks its institution out of this cached list. Navigating
// from the list is therefore instant, and a direct URL hit or refresh refetches
// the list and still resolves. Swap this for a detail call when one exists —
// nothing outside this hook and the page's lookup needs to change.
export const INSTITUTIONS_QUERY_KEY = ['bank-institutions']

export const useInstitutions = () =>
  useQuery<IBankInstitution[]>({
    queryKey: INSTITUTIONS_QUERY_KEY,
    queryFn: () => BankService.fetchBankInstitutions(),
  })
